"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const InlineDialog_1 = __importDefault(require("components/design-system/inline-dialog/InlineDialog"));
const MenuOutsideClickWrapper_1 = __importDefault(require("components/objectives/compact-objective/fragments/MenuOutsideClickWrapper"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const DropdownSelectUserPhase = ({ revieweeOrReviewerWording, setSearch, _onScroll, suggestion, excludeUser, selectUser }) => {
    const [useTrigger, setUseTrigger] = (0, react_1.useState)(true);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement(MenuOutsideClickWrapper_1.default, { event: () => setUseTrigger(true) },
                react_1.default.createElement(InlineDialog_1.default, { header: (0, HelperUtils_1.getObjectiveLocale)(`Add ${revieweeOrReviewerWording}s`), customClass: "w-full" },
                    react_1.default.createElement(InlineDialog_1.default.Trigger, null,
                        react_1.default.createElement(SearchBar_1.default, { placeholder: "Search employee", onChange: (e) => setSearch(e.currentTarget.value), onFocus: () => setUseTrigger(false), fullWidth: true, iconFillColor: "var(--n-600)", dataCy: "trigger-project-alignment", containerClass: "mb-[16px]" })),
                    !useTrigger && (react_1.default.createElement(InlineDialog_1.default.MenuItems, { useTrigger: useTrigger, customClass: "w-full max-h-[288px]", maxHeightWrapper: 240, onScroll: (e) => _onScroll(e) }, suggestion === null || suggestion === void 0 ? void 0 : suggestion.map((user, index) => !excludeUser.includes(user.id) && (react_1.default.createElement(InlineDialog_1.default.MenuItem, { onClick: () => {
                            selectUser(user);
                            setUseTrigger(true);
                        }, key: index },
                        react_1.default.createElement(ProfileType_1.default, { user: user, title: user === null || user === void 0 ? void 0 : user.name, subtitle: user === null || user === void 0 ? void 0 : user.jobTitle, srcPicture: user === null || user === void 0 ? void 0 : user.profilePicture, size: 32, titleClassName: "typography-h400", subtitleClassName: "typography-h400 text-n-800", customClass: "w-[232px]" })))))))))));
};
exports.default = DropdownSelectUserPhase;
